export default __webpack_public_path__ + "static/media/Overrated_Big.55c6d765.svg";